import React from "react";

export function twentySeven() {
  return (
    <div>
      <div className="para">
        I was just going through the entries on this website, they are all very
        juvenile. I do not want to get rid of any of them though, they are
        snapshots of the time they were written in. I had another{" "}
        <a href="https://github.com/narengogi/chintamani">corner</a> where I
        experimented for a good two years with a custom graph engine for storing
        information, it fell into disuse and the DB is deleted now. Text
        survives.
      </div>
      <div className="para">
        I was also wondering if I should migrate this website to render static
        html and index it better. I could make use of Claude to do it. I'm
        deferring the thought for now. I would like for some of these spaces to
        remain as they are. (Unrelated) No one writes much of anything anymore.
        Journals, code, meaningful little notes. Sadly, my friends have stopped
        making things too.
      </div>
      <div className="imgContainer">
        <img
          src="https://raw.githubusercontent.com/narengogi/nathsin-v2/master/src/assets/images/dead-feedly.png"
          alt="rss feeder"
          className="image"
        />
      </div>
      <div className="para">
        I’m always dreading having to check my screen-time, especially on the
        mobile phone, the phone use for me, it takes away from any meaningful
        pursuit. This is a discussion I keep returning to
        <a href="https://www.naths.in/blog/unvaried">
          (https://www.naths.in/blog/unvaried)
        </a>
        . I was going through my journals and it is the same theme over and over
        there too, paranoid for not being sufficiently in control, on letting
        algorithmic feeds influence my behaviour.
      </div>
      <div className="para">
        The only projects I got done last year were{" "}
        <a href="https://github.com/narengogi/map-of-goodreads">
          mapping goodreads
        </a>{" "}
        and an{" "}
        <a href="https://github.com/narengogi/portkey-led-board">
          LED installation at my workplace.
        </a>{" "}
        I would like to find some time for myself, to leisurely walk to a
        fresh-water stream, to break into a run, and to be able to keep my phone
        switched off.
      </div>
    </div>
  );
}
